import React from 'react';
import SEO from '@/components/SEO';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const DisclaimerPage = () => {
  return (
    <>
      <SEO
        title="Disclaimer | AssetWise Business Consultants"
        description="Disclaimer for AssetWise Business Consultants - interest rates and services information."
        path="/disclaimer"
      />

      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-cyan-600 hover:text-cyan-700 mb-6">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Link>

          <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-8">Disclaimer</h1>

            <div className="prose prose-lg max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">General Information</h2>
                <p className="text-gray-700 leading-relaxed">
                  All content on this website is provided for informational purposes only and does not constitute professional advice.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">No Financial or Legal Advice</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  AssetWise does not provide:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
                  <li>Certified financial planning</li>
                  <li>Investment advisory services</li>
                  <li>Legal representation</li>
                </ul>
                <p className="text-gray-700 leading-relaxed">
                  Users should consult qualified professionals before making decisions.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Loan Disclaimer</h2>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Loan approvals, interest rates, and disbursement are determined solely by lenders</li>
                  <li>AssetWise only facilitates the process and does not influence credit decisions</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Accuracy & Updates</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  While we strive for accuracy:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Information may contain errors or omissions</li>
                  <li>Content may change without prior notice</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Third-Party Disclaimer</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  We are not responsible for:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Policies, actions, or decisions of banks/NBFCs</li>
                  <li>Any agreements entered into with third parties</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Risk Disclosure</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Users acknowledge that:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Financial and property transactions involve inherent risks</li>
                  <li>AssetWise is not liable for outcomes of such decisions</li>
                </ul>
              </section>
            </div>

            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-600">
                Last Updated: April 2026
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DisclaimerPage;
